export const COMMUNITY_EMOJI_CATEGORIES: { id: string; label: string; emojis: string[] }[] = [
  {
    id: 'smileys',
    label: 'Smileys',
    emojis: [
      '😀', '😃', '😄', '😁', '😅', '😂', '🤣', '😊', '😇', '🙂', '😉', '😍', '🥰', '😘',
      '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑',
      '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕',
      '🤢', '🤮', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐',
    ],
  },
  {
    id: 'gestures',
    label: 'Gestures',
    emojis: ['👍', '👎', '👏', '🙏', '💪', '🤝', '✌️', '🤞', '🤟', '🤘', '👋', '🖐️', '✋', '🤚'],
  },
  {
    id: 'hearts',
    label: 'Hearts',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓'],
  },
  {
    id: 'objects',
    label: 'Objects',
    emojis: ['🔥', '💯', '✨', '⭐', '🎉', '✅', '❌', '💬', '📎', '📷', '📍', '🎵', '📄', '🎥'],
  },
];

export const COMMUNITY_QUICK_EMOJIS = COMMUNITY_EMOJI_CATEGORIES.flatMap((c) => c.emojis);
